"use strict";
// https://github.com/Chia-Network/chia-blockchain/blob/b7e8e9c9a67fd696cfa2c16747d64dc0c3224611/chia/protocols/shared_protocol.py#L24
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Handshake = exports.Capability = exports.PROTOCOL_VERSION = void 0;
const fields_1 = __importDefault(require("./fields"));
exports.PROTOCOL_VERSION = "0.0.33";
var Capability;
(function (Capability) {
    Capability[Capability["BASE"] = 1] = "BASE";
})(Capability = exports.Capability || (exports.Capability = {}));
class Handshake {
}
__decorate([
    fields_1.default.String()
], Handshake.prototype, "networkId", void 0);
__decorate([
    fields_1.default.String()
], Handshake.prototype, "protocolVersion", void 0);
__decorate([
    fields_1.default.String()
], Handshake.prototype, "softwareVersion", void 0);
__decorate([
    fields_1.default.Uint(16)
], Handshake.prototype, "serverPort", void 0);
__decorate([
    fields_1.default.Uint(8)
], Handshake.prototype, "nodeType", void 0);
__decorate([
    fields_1.default.List(fields_1.default.Tuple([fields_1.default.Uint(16), fields_1.default.String()]))
], Handshake.prototype, "capabilities", void 0);
exports.Handshake = Handshake;
//# sourceMappingURL=shared_protocol.js.map